export const rgbaToString = (r: number, g: number, b: number, a: number) => {
    return `rgba(${ r }, ${ g }, ${ b }, ${ a } )`;
};